<div class="flex flex-col gap-4 p-6">
    <!-- Alerta de sesión activa -->
    @if (activeSessionData?.hasActiveSession) {
        <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-md">
            <div class="flex items-start">
                <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-yellow-800">
                        Sesión activa detectada en esta máquina
                    </h3>
                    <div class="mt-2 text-sm text-yellow-700">
                        <div class="grid grid-cols-1 gap-1">
                            @if (activeSessionData?.operatorName) {
                                <p><strong>Operario:</strong> {{ activeSessionData?.operatorName }}</p>
                            }
                            @if (activeSessionData?.orderNumber) {
                                <p><strong>Orden:</strong> {{ activeSessionData?.orderNumber }}</p>
                            }
                            @if (activeSessionData?.processName) {
                                <p><strong>Proceso:</strong> {{ activeSessionData?.processName }}</p>
                            }
                            @if (activeSessionData?.processDescription) {
                                <p><strong>Descripción:</strong> {{ activeSessionData?.processDescription }}</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (!showOnlyLastPackage) {
        <div class="flex items-center gap-3">
           <!--  <button
                type="button"
                (click)="openManualAddModal()"
                class="p-2 bg-blue-500 hover:bg-blue-600 text-white rounded-full transition-colors"
                nz-tooltip
                nzTooltipTitle="Añadir materia prima manualmente">
                <img src="assets/icons/plus-icon.svg" alt="Añadir" class="h-6 w-6 invert" />
            </button> -->

            <div class="flex-1 flex gap-2">
                <textarea
                    #barcodeInput
                    nz-input
                    class="flex-1 h-10 px-3 py-2 border border-gray-300 rounded-md resize-none overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Escanee código de barras de la materia prima"
                    rows="1"
                    [(ngModel)]="barcodeValue"
                    (keydown.enter)="onBarcodeInput(); $event.preventDefault()">
                </textarea>

                <button
                    nz-button
                    nzType="primary"
                    (click)="onBarcodeInput()"
                    [disabled]="!barcodeValue.trim() || isLoading()"
                    class="button primary-button">
                    Buscar
                </button>
            </div>
        </div>
    }

    @if (showOnlyLastPackage || (hasExistingRawMaterialUsed && !showOnlyLastPackage && processStatusId && processStatusId !== StatusEnum.AWAITING && availablePackages.length > 0)) {
        <div class="flex flex-col gap-3">
            @if (articleUseSensors) {
                <div class="flex items-center gap-2 p-3 bg-gray-50 rounded-md">
                    <input
                        type="checkbox"
                        id="materialConsumedCheckbox"
                        [checked]="isCurrentMaterialConsumed()"
                        (change)="isCurrentMaterialConsumed.set($any($event.target).checked)"
                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer" />
                    <label
                        for="materialConsumedCheckbox"
                        class="text-sm font-medium text-gray-700 cursor-pointer select-none">
                        Materia prima actual consumida completamente
                    </label>
                </div>
            }

            <label class="text-sm font-medium text-gray-700">Pedir último paquete</label>
            <nz-select
                nzPlaceHolder="Seleccione paquete"
                nzShowSearch="true"
                [(ngModel)]="selectedPackage"
                class="w-full">
                @for (pkg of filteredPackages(); track pkg.id) {
                    <nz-option
                        [nzValue]="pkg.id"
                        [nzLabel]="pkg.packagingType?.name + ' - ' + (pkg.externalBatchNumber || pkg.batchNumber)">
                    </nz-option>
                }
            </nz-select>
        </div>
    }

    @if (isLoading()) {
        <div class="flex justify-center py-4">
            <app-loader></app-loader>
        </div>
    }

    @if (searchMessage()) {
        <div class="text-center text-sm py-2 px-4 rounded-md" [ngClass]="{
            'bg-green-100 text-green-700': searchSuccess(),
            'bg-red-100 text-red-700': !searchSuccess()
        }">
            {{ searchMessage() }}
        </div>
    }
</div>

<div class="flex justify-end gap-2 p-4 border-t">
    <button
        (click)="handleCancel()"
        class="button secondary-button"
        [disabled]="isLoading()">
        Cancelar
    </button>

    @if (showOnlyLastPackage) {
        <button
            nz-button
            nzType="primary"
            class="button primary-button"
            (click)="requestLastPackage()"
            [disabled]="!selectedPackage || isLoading()">
            Enviar
        </button>
    } @else {
        <button
            nz-button
            nzType="primary"
            class="button primary-button"
            (click)="handleSubmit()"
            [disabled]="!scannedArticleBatch() || isLoading()">
            Enviar
        </button>
    }
</div>

